import { removeDiacritics } from "./stringUtils";

export const RegimeOptions: Record<string | number, string> = {
    "1": "Laboral",
    "2": "Pós Laboral",
    "3": "Distância",
  };
    



export function mapRegime(value: string | number): string {
  if (!value) return "1";

  if (RegimeOptions[value]) {
    return value.toString();
  }

  const normalizedInput = removeDiacritics(value.toString().toLowerCase().trim());

  const match = Object.entries(RegimeOptions).find(([key, label]) => {
    const normalizedLabel = removeDiacritics(label.toLowerCase());
    return normalizedInput === normalizedLabel;
  });

  return match ? match[0] : "1"; 
}
